import {NgModule} from "@angular/core";
import {MatListModule} from "@angular/material/list";
import {MatIconModule} from "@angular/material/icon";
import {MatCardModule} from "@angular/material/card";
import {MatMenuModule} from "@angular/material/menu";
import {MatInputModule} from "@angular/material/input";
import {MatTableModule} from "@angular/material/table";
import {MatRadioModule} from "@angular/material/radio";
import {MatChipsModule} from "@angular/material/chips";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";
import {MatSelectModule} from "@angular/material/select";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDividerModule} from "@angular/material/divider";
import {MatStepperModule} from "@angular/material/stepper";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatNativeDateModule} from "@angular/material/core";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatSnackBarModule } from '@angular/material/snack-bar'; 

@NgModule({
    declarations: [],
    imports: [
        MatIconModule,
        MatListModule,
        MatCardModule,
        MatMenuModule,
        MatInputModule,
        MatTableModule,
        MatRadioModule,
        MatChipsModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        MatStepperModule,
        MatDividerModule,
        MatToolbarModule,
        MatSidenavModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatSnackBarModule
    ],
    exports: [
        MatIconModule,
        MatListModule,
        MatCardModule,
        MatMenuModule,
        MatInputModule,
        MatTableModule,
        MatRadioModule,
        MatChipsModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        MatStepperModule,
        MatDividerModule,
        MatToolbarModule,
        MatSidenavModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        MatSnackBarModule
    ],
})
export class MaterialModule {
}
